import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  InjectionToken,
  OnDestroy,
  OnInit,
  DOCUMENT
} from '@angular/core';
import { Page } from '@bloomreach/spa-sdk';
import { BrPageComponent } from '@bloomreach/ng-sdk';

import { ActivatedRoute, NavigationEnd, Router, Data } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from '@env/environment';
import { WINDOW } from '@app/shared/utilities/window';

import { OverlayService } from '@app/core/services/overlay.service';

export const CMS_BASE_URL = new InjectionToken<string>('brXM Base URL');
export const SPA_BASE_URL = new InjectionToken<string>('SPA Base URL');

@Component({
    selector: 'mflooring-entry-component',
    templateUrl: './entry.component.html',
    styleUrls: ['./entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class EntryComponent implements OnInit, OnDestroy {
	public configuration: BrPageComponent['configuration'];

	public mapping = {};
	public navigationEnd$: Observable<NavigationEnd>;
	public pageTemplate: string;
	isOverlayVisible = false;
	shopPage = false;

	private destroy$ = new Subject<void>();

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		@Inject(WINDOW) private windowRef: Window,
		@Inject(DOCUMENT) private documentRef: Document,
		@Inject(CMS_BASE_URL) cmsBaseUrl: string,
		@Inject(SPA_BASE_URL) spaBaseUrl: string,
		private overlayService: OverlayService
	) {
		this.configuration = {
			endpoint: environment.cmsBaseUrl + '/resourceapi',
			path: router.url,
		} as BrPageComponent['configuration'];

		this.navigationEnd$ = this.router.events.pipe(
			filter((event: any) => event instanceof NavigationEnd)
		) as Observable<NavigationEnd>;
	}

	get isHardwoodLanding(): boolean {
		return this.router.url?.split('?')[0] === '/hardwood-v2';
	}

	getPageTemplate(page) {
		return page?.root?.model?.meta?.params?.template || 'single-column';
	}

	setVisitor(page?: Page) {
		this.configuration.visitor = page?.getVisitor();
	}

	ngOnInit() {
		this.activatedRoute?.data?.pipe(
			takeUntil(this.destroy$)
		).subscribe((data: Data) => {
			this.shopPage = this.router.url?.includes('/shop/')
			this.mapping = data['componentMapping'];
		});

		this.navigationEnd$.pipe(
			takeUntil(this.destroy$)
		).subscribe((event: NavigationEnd) => {
			this.configuration = {
				...this.configuration,
				path: event.url,
			};
		});

		// this.overlayService.overlayVisible$.subscribe(visible => {
		// 	this.isOverlayVisible = visible;
		// });
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
